import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, withKeys as _withKeys, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "d-flex flex-column justify-center align-center" };
const _hoisted_2 = { class: "d-flex justify-space-between" };
const _hoisted_3 = { class: "d-block text-subtitle-1 font-weight-medium text-black" };
const _hoisted_4 = { class: "brg-color-grey-600 text__information" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DialogHeader = _resolveComponent("DialogHeader");
    const _component_v_switch = _resolveComponent("v-switch");
    const _component_v_card = _resolveComponent("v-card");
    const _component_DialogFooter = _resolveComponent("DialogFooter");
    const _component_v_dialog = _resolveComponent("v-dialog");
    return (_openBlock(), _createBlock(_component_v_dialog, {
        modelValue: _ctx.isOpen,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.isOpen) = $event)),
        width: "436",
        "onClick:outside": _ctx.handleClickClose,
        onKeydown: _withKeys(_ctx.handleClickClose, ["esc"])
    }, {
        default: _withCtx(() => [
            _createVNode(_component_v_card, { color: "#eee" }, {
                default: _withCtx(() => [
                    _createVNode(_component_DialogHeader, {
                        title: _ctx.$t(`${_ctx.lc}dialog_title`),
                        "on-cancel": _ctx.handleClickClose,
                        class: "root-dialog__header"
                    }, null, 8 /* PROPS */, ["title", "on-cancel"]),
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_v_card, { class: "root-dialog__inner-card" }, {
                            default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.configList, (list, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: list.title
                                    }, [
                                        _createElementVNode("div", _hoisted_2, [
                                            _createElementVNode("div", {
                                                class: _normalizeClass(_ctx.checkConfigLabelPadding(index))
                                            }, [
                                                _createElementVNode("span", _hoisted_3, _toDisplayString(list.title), 1 /* TEXT */),
                                                _createElementVNode("span", _hoisted_4, _toDisplayString(list.subTitle), 1 /* TEXT */)
                                            ], 2 /* CLASS */),
                                            _createVNode(_component_v_switch, {
                                                modelValue: list.switchData,
                                                "onUpdate:modelValue": ($event) => ((list.switchData) = $event),
                                                color: "primary",
                                                class: "pr-2",
                                                density: "compact"
                                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"])
                                        ])
                                    ]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _createVNode(_component_DialogFooter, {
                        "ok-only": true,
                        "on-ok": _ctx.handleClickOk
                    }, {
                        "ok-only": _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.lc}dialog_footer_button_text`)), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["on-ok"])
                ]),
                _: 1 /* STABLE */
            })
        ]),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue", "onClick:outside", "onKeydown"]));
}
